// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import caseMng from './metaData/case'
export default {
  state: caseMng,
  actions
}
